import { createRouter, createWebHashHistory } from 'vue-router'
const router = createRouter({
  history: createWebHashHistory(), // 这里必须是history模式 其他模式会导致后面打包生成的静态文件内容都是一样的，不能起到预渲染的作用
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/Index.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/itemsList',
      name: 'itemsList',
      component: () => import('../views/ItemsList.vue')
    },
    {
      path: '/itemDetail',
      name: 'itemDetail',
      component: () => import('../views/ItemDetail.vue')
    },
    {
      path: '/shopList',
      name: 'shopsList',
      component: () => import('../views/ShopList.vue')
    },
    {
      path: '/shopDetail',
      name: 'shopDetail',
      component: () => import('../views/ShopDetail.vue')
    },
    {
      path: '/shopCar',
      name: 'shopCar',
      component: () => import('../views/ShopCar.vue')
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('../views/ContactUs.vue')
    },
    {
      path: '/favoriteShop',
      name: 'favoriteShop',
      component: () => import('../views/FavoriteShop.vue')
    },
    {
      path: '/favoriteProducts',
      name: 'favoriteProducts',
      component: () => import('../views/favoriteProducts.vue')
    },
    {
      path: '/internetHistory',
      name: 'internetHistory',
      component: () => import('../views/internetHistory.vue')
    },
    {
      path: '/aaa',
      name: 'aaa',
      component: () => import('../views/aaa.vue')
    },
  ]
})

export default router

